import _SvgIcon from "@mui/material/SvgIcon";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
export function SharedBikeIcon(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon, _extends({
    viewBox: "0 0 32 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.0643 1.92833C20.0643 1.92833 16.2522 1.67651 16.0004 1.92833C15.3681 2.56063 14.5883 4.96376 13.9364 7.3468C13.1916 10.0691 12.6139 12.7652 12.6139 12.7652M17.355 6.66949L14.6458 4.94562",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "1.36227"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12.6135",
    cy: "12.7661",
    fill: "none",
    r: "4.73731",
    stroke: "currentColor",
    strokeWidth: "1.36227"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: "10.8292",
    rx: "1.41277",
    stroke: "currentColor",
    strokeWidth: "1.36227",
    width: "4.05618",
    x: "20.0675",
    y: "6.56199"
  }));
}